import React from 'react';

export default function AboutTeamImage() {
    return process.env.DEFAULT_LANGUAGES === 'de' ? (
        <div className="about-team-image-de"/>
    ) : (
        <div className="about-team-image"/>
    );
}



// WEBPACK FOOTER //
// ./src/components/content/about/AboutTeamImage.jsx